define('widgets/pagedView/viewmodel',['plugins/widget', 'durandal/composition', 'jquery', 'knockout', 'services/trace', 'models/controller', 'models/account'],
function (widget, composition, $, ko, trace, model, account) {
	var ctor = function () { };

	ctor.prototype.controller = function () {
		return this.settings.controller;
	};

	ctor.prototype.activate = function (settings) {
		this.settings = settings;

		if (this.controller().result().length === 0 && this.controller().isLoading() === false) {
			return Q.when(this.controller().load());
		}

		return true;
	};

	ctor.prototype.refresh = function () {
		return Q.when(this.controller().load());
	};

	ctor.prototype.sort = function (column, operator) {
		var sort = this.controller().buildSort(column, operator);

		this.controller().sortDefinitions.replace(sort);
	};

	ctor.prototype.filter = function (column, operator, needle, list) {
		var filter = this.controller().buildFilter(column, operator, needle, list);

		this.controller().filterDefinitions.replace(filter);
	};

	ctor.prototype.nextPage = function () {
		this.setPage(this.controller().currentPage() + 1);
	};

	ctor.prototype.lastPage = function() {
		this.setPage(this.controller().pageCount());
	};

	ctor.prototype.previousPage = function () {
		this.setPage(this.controller().currentPage() - 1);
	};

	ctor.prototype.firstPage = function () {
		this.setPage(1);
	};

	ctor.prototype.setPage = function (pageToSet) {

		if (pageToSet > this.controller().pageCount()) return;
		if (pageToSet < 1) return;
		if (pageToSet === this.controller().currentPage()) return;

		this.controller().gotoPage(pageToSet);
	};


	ctor.prototype.setRowCount = function(count) {
		account.Session.rowCount = count;

		this.controller().pageSize(count);
		Q.when(this.controller().load());
	};

	return ctor;
});

